import { useUnit } from 'effector-react';
import { CircularProgress } from '@mui/material';
import { $isLocalLoading } from '../../model/save';

export const LocalLoader = () => {
  const isLocalLoading = useUnit($isLocalLoading);

  if (!isLocalLoading) return null;

  return <CircularProgress size={16} />;
};
